import * as React from "react";
import { MessageSquareOff } from "lucide-react";
import { Loader } from "@/components/ui/loader";

import { useGetRecentQAConversationsQuery } from "../api";
import { RecentQARow } from "./RecentQARow";

export const RecentQATable: React.FC = () => {
  const { data, isLoading } = useGetRecentQAConversationsQuery({ offset: 0, limit: 50 });

  if (isLoading) {
    return (
      <div className="flex h-64 w-full items-center justify-center">
        <Loader className="h-8 w-8 text-gray-400" />
      </div>
    );
  }

  if (!data || data.results.length === 0) {
    return (
      <div className="flex h-64 flex-col items-center justify-center gap-2 text-muted-foreground">
        <MessageSquareOff className="h-12 w-12" />
        <p className="text-lg font-semibold">No Q&A conversations found</p>
        <p className="text-sm">Start a conversation by navigating to a document and asking questions.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {data.results.map(conversation => (
        <RecentQARow key={conversation.conversation_id} conversation={conversation} />
      ))}
    </div>
  );
};
